import React,{ useEffect, useState, useRef, useContext } from 'react'
import Layout from '../layout/default';
import {Icon, Block, BlockHead, BlockHeadBetween, BlockHeadContent, DatePicker, TimePicker } from '../components';
import { monthList} from '../utilities';
import {Popover,OverlayTrigger, Modal, Row, Col,Button, Card, Form} from 'react-bootstrap'
import FullCalendar, { CalendarApi, CalendarDataManager, CalendarRoot } from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import bootstrapPlugin from '@fullcalendar/bootstrap'
import listPlugin from '@fullcalendar/list'
import Spinner from 'react-bootstrap/Spinner';
import { Navigate } from "react-router-dom";
import toTimeOnly from '../utilities/toTimeOnly';
import JobsheetDetail from '../components/Jobsheet/JobsheetDetail';
import RefreshNotifications from '../components/NotificationHub/RefreshNotifications';
import { AppContext } from '../context/AppContext';
import { useApiClient } from '../ApiService/useApiClient';


const baseURL = "HMCareTask/summarytasklist/";
const baseURL2 = "HMCareStaff/stafflist/";    


let calendarRef = React.createRef();

function renderEventContent(eventInfo) {
    
  const timeText = eventInfo.timeText, 
        title = eventInfo.event._def.title,         
        description = eventInfo.event._def.extendedProps.description, 
        serviceType = eventInfo.event._def.extendedProps.serviceType,
        serviceTypeName = eventInfo.event._def.extendedProps.serviceTypeName,
        fundingType = eventInfo.event._def.extendedProps.fundingType, 
        carerAssignments = eventInfo.event._def.extendedProps.carerAssignments, 
        start = eventInfo.event.startStr,           
        end = eventInfo.event.endStr,    
        view = eventInfo.view.type,
        
        popover = (
          <Popover className='event-popover'>
            <Popover.Header as="h3">{title}</Popover.Header>
            <Popover.Body>
                <Icon variant="primary" size="4" name="clock"></Icon>
                {toTimeOnly(start)} - {toTimeOnly(end)}<br></br>                
                Service : {serviceTypeName} <br></br>
                Funding : {fundingType}<br></br>
                Assigned Carer(s) : {carerAssignments} <br></br>                
                </Popover.Body>
          </Popover>
        )
       

  return (
    <>
      
      {start && end && <div className="fc-event-time"><Icon name="clock"></Icon> {toTimeOnly(start)} - {toTimeOnly(end)}</div>} 
     
      <div className="fc-event-title">{title}</div>
      <OverlayTrigger trigger={['hover','focus']} placement="top" overlay={popover}>
        <div className='fc-event-popover' style={{position:'absolute', inset: '0'}}></div>
      </OverlayTrigger>
      
    </>
  )
}



function JobScheduleStaffMyAccount() {

    const api = useApiClient()
    const { user, SiteConfig } = useContext(AppContext);

// eslint-disable-next-line 
const modalForm = useRef(null);
const selectEvent = []
const formDefault = {
    opened: false
}

    const [events, setEvents] = useState(null);
    const [selectedEvent, setSelectedEvent] = useState(selectEvent);
    const [previewModal, setPreviewModal] = useState(false);
    
       
    const [RefreshData, setRefresh] = useState(0);

    const[clients, setClients] = useState(null);  
    
    const[error, setError] = useState(null); 


const [CurrentDatesetStart, setCurrentDatesetStart] = useState(new Date().toISOString())
const [CurrentDatesetEnd, setCurrentDatesetEnd] = useState(new Date().toISOString())

const[isLoading, setIsLoading] = useState(true)


const ApiGetData = async (URL,setdataFunc, setErrorFunc) => {
  try{
  const response = await api.get(URL);
      setdataFunc(response.data);        
  } catch(error) {
      setErrorFunc(error);      
  }
};


useEffect(() => {
  ApiGetData(baseURL2, setClients, setError); // fetch clients only
}, []);
    
    
    function closePreviewModal(){
      setPreviewModal(false);
    }

    
    function clientSelect(){     
        const DataUrl = baseURL + CurrentDatesetStart +'/'+ CurrentDatesetEnd +'/ /'+ SiteConfig.CURRENT_USER_ID
        ApiGetData(DataUrl,setEvents, setError);        
      }
    

                    
    const globalFcStyle = `
        .fc-list-event-title {
          position:relative;
        }
    `
    
    function handleEventClick(eventInfo){
      let title = eventInfo.event._def.title;
      let description = eventInfo.event._def.extendedProps.description;
      let start = eventInfo.event._instance.range.start;
      let startDate = start.getFullYear() + '-' + String(start.getMonth() + 1).padStart(2, '0') + '-' + String(start.getDate()).padStart(2, '0');
      let startDateEng = String(start.getDate()).padStart(2, '0') + ' ' + monthList[start.getMonth()] + ' ' + start.getFullYear();
      let startTime = start.toUTCString().split(' '); startTime = startTime[startTime.length-2]; startTime = (startTime === '00:00:00') ? '' : startTime;
      let end = eventInfo.event._instance.range.end;
      let endDate = end.getFullYear() + '-' + String(end.getMonth() + 1).padStart(2, '0') + '-' + String(end.getDate()).padStart(2, '0');
      let endDateEng = String(end.getDate()).padStart(2, '0') + ' ' + monthList[end.getMonth()] + ' ' + end.getFullYear();
      let endTime = end.toUTCString().split(' '); endTime = endTime[endTime.length-2]; endTime = (endTime === '00:00:00') ? '' : endTime;
      let className = eventInfo.event._def.ui.classNames[0].slice(3);
      let eventId = eventInfo.event._def.publicId;
      
      let serviceType = eventInfo.event._def.extendedProps.serviceType;
      let fundingType = eventInfo.event._def.extendedProps.fundingType;
      let serviceTypeName = eventInfo.event._def.extendedProps.serviceTypeName;
      let carerAssignments = eventInfo.event._def.extendedProps.carerAssignments;
      let carerAssignmentIds = eventInfo.event._def.extendedProps.carerAssignmentIds;

       // alert(fundingType +''+serviceType)

        // console.log(eventId)
        // return null

      const currentEvent = {...selectedEvent, 
        id:eventId,
        title:title, 
        description:description, 
        className:className, 
        startTime: startTime,
        startDate: startDate,
        startDateEng: startDateEng,
        endTime: endTime,
        endDate: endDate,
        endDateEng: endDateEng,
        serviceType : serviceType,
        fundingType : fundingType,
        carerAssignments : carerAssignments,
        serviceTypeName : serviceTypeName,
        carerAssignmentIds : carerAssignmentIds,
      }
      setSelectedEvent(currentEvent);
      setPreviewModal(true)
    }

        

function datesSetChange(dataInfo) {
  setIsLoading(true);

  const DataUrl = baseURL + dataInfo.startStr + '/' + dataInfo.endStr + '/ /' + SiteConfig.CURRENT_USER_ID;

  ApiGetData(DataUrl, (data) => {
    setEvents(data);
    setIsLoading(false);
  }, setError);

  setCurrentDatesetStart(dataInfo.startStr);
  setCurrentDatesetEnd(dataInfo.endStr);
}


    if (error) 
    {      
      if(error.message.indexOf("status code 401")){
        return <Navigate to="/auths/auth-login" />
      } else
      return "Error: ${error.message}";
    }

    if(!events || !clients || isLoading) (
        <Layout title="Clients" content="container"><Spinner animation="border" variant="primary" /></Layout>
    );
    
    return (
        <>
        <RefreshNotifications setRefresh={setRefresh} />         
        <Layout title="HMCarePlanner - Schedules" content="container">
                 
            <Block>
                <Card>
                    <Card.Body>
                        <style>{globalFcStyle}</style>
                        {isLoading && <p>Loading...</p>}
                        <FullCalendar                            
                            ref={calendarRef}
                            // customButtons={{ myCustomButton: {
                            //     text: 'custom!',
                            //     click: function() {
                            //       alert('clicked the custom button!');

                            //       let calendarApi = calendarRef.current.getApi();
                            //       calendarApi.next();
                            //     }
                            //   }}}
                            isLoading={isLoading} // use a function 
                            noEventsText={"No schedules"}                            
                            events= {events}
                            plugins={[ dayGridPlugin, timeGridPlugin, interactionPlugin, bootstrapPlugin, listPlugin ]}
                            //initialView="dayGridMonth"
                            initialView="listWeek"
                            timeZone= 'UTC'
                            themeSystem= 'bootstrap'

                            datesSet={(dateInfo) => {
                                //console.log(dateInfo.start) //start of the range the calendar date
                                //console.log(dateInfo.end) //end of the range the calendar date
                                datesSetChange(dateInfo)
                            }}
                            
                            dateClick={(dateInfo)=>{
                                //console.log(dateInfo.date +'==='+dateInfo.date)    
                            }}

                            headerToolbar= {{
                                // left: 'title prev,next,myCustomButton',
                                left: 'title prev,next',
                                center: null,
                                right: 'today dayGridMonth,timeGridWeek,timeGridDay,listWeek'
                            }}
                            height= {800}
                            contentHeight= {780}                            
                            aspectRatio= {3}
                            editable= {true}
                            droppable= {true}
                            views= {{
                                dayGridMonth: {
                                    dayMaxEventRows: 10,                                    
                                }
                            }}                            
                            eventContent={renderEventContent}
                            eventClick={handleEventClick}                                                   
                        />
                    </Card.Body>
                </Card>
            </Block>
            
        </Layout>
      

        <Modal show={previewModal} onHide={closePreviewModal} size="xl">
            <Modal.Header closeButton>
              <Modal.Title className="event-title" as="h4">{selectedEvent.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <JobsheetDetail taskid={selectedEvent.id} />              
              </div>
            </Modal.Body>
            <Modal.Footer>                
                <Button variant="light" onClick={closePreviewModal}>Cancel</Button>
            </Modal.Footer>
        </Modal>
               
        </>
    )
}

export default JobScheduleStaffMyAccount